// extracted by mini-css-extract-plugin
export var altaccent = "Button-module--altaccent--e06e2";
export var button = "Button-module--button--5b976";
export var ghost = "Button-module--ghost--425f3";
export var hasSvg = "Button-module--has-svg--0cf88";
export var inline = "Button-module--inline--8765d";
export var inverted = "Button-module--inverted--64f90";
export var lgSize = "Button-module--lg-size--2f14e";
export var lightblue = "Button-module--lightblue--9de57";
export var mdSize = "Button-module--md-size--30f29";
export var pseudoFill = "Button-module--pseudo-fill--6dec8";
export var reversed = "Button-module--reversed--c4f5b";
export var xlSize = "Button-module--xl-size--807f7";